import { Component, Input, ViewEncapsulation, Host, Optional } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { LoadingStateService } from '../../providers/loading-state/loading-state.service';
import { CardComponent } from '../card/card.component';

@Component({
    selector: 'tidy-button',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./button.component.scss'],
    template: `
    <div class="wrapper">
      <button
        expand="block"
        [ngClass]="{
          'mat-flat-button': hasATidyCardHost,
          'mat-raised-button': !hasATidyCardHost,
          'small-body-button': smallBody
        }"
        mat-button
        [disabled]="(disabled || (loadingState.loading && !disableLoadingStyle))"
        tappable
        (click)="executeAction()"
        [type]="type" block
        >
        @if (image) {
          <tidy-image [src]="image" [width]="imageWidth"></tidy-image>
        }
        @if (!actionLoading && !smallText && !smallBody) {
          <tidy-text [largeBody]="text"></tidy-text>
        }
        @if (!actionLoading && smallText) {
          <tidy-text [body]="text"></tidy-text>
        }
        @if (!actionLoading && smallBody) {
          <tidy-text [smallBody]="text"></tidy-text>
        }
        @if (actionLoading && !disableLoadingStyle) {
          <ion-spinner></ion-spinner>
        }
      </button>
    </div>
    `,
    standalone: false
})
export class ButtonComponent {

  @Input() image: string;
  @Input() imageWidth: string;
  @Input() text: string;
  @Input() type = 'submit';
  @Input() disabled = false;
  @Input() action = null;
  @Input() smallText = false;
  @Input() smallBody = false;
  @Input() disableLoadingStyle = false;
  actionLoading: boolean;

  constructor(
    public loadingState: LoadingStateService,
    private toastCtrl: ToastController,
    @Optional() @Host() public hasATidyCardHost: CardComponent
  ) { }

  async executeAction() {
    if (this.loadingState.loading || !this.action) {
      return;
    }

    try {
      this.loadingState.loading = true;
      this.actionLoading = true;
      await this.action();
    } catch (error) {
      await this.showError(error);
    } finally {
      this.loadingState.loading = false;
      this.actionLoading = false;
    }
  }

  async showError(error) {
    // `error` is the raw thrown value, which can be a string, { error: 'msg' },
    // { error: { message } }, or { message }. Passing it straight to the toast
    // rendered the literal "undefined". Extract a real message; show nothing if
    // there isn't one (the action's own inline error handling still applies).
    const message =
      (error?.error && typeof error.error === 'object' && error.error.message) ||
      (typeof error?.error === 'string' ? error.error : '') ||
      error?.message ||
      (typeof error === 'string' ? error : '');

    if (!message || `${message}`.trim().toLowerCase() === 'undefined') {
      return;
    }

    await (await this.toastCtrl.create({ message, duration: 3000 })).present();
  }
}
